import { useRouterState } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { Suspense } from "react";

interface RouteTransitionProps {
  children: React.ReactNode;
}

export function RouteTransitionHandler({ children }: RouteTransitionProps) {
  const pending = useRouterState({ select: (s) => s.status === "pending" });

  const spinner = <Loader2 className="animate-spin w-6 h-6 fixed bottom-4 right-4 z-50" />;

  return (
    <>
      {pending ? spinner : null}
      <div className={pending ? "opacity-50" : ""}>
        <Suspense fallback={spinner}>{children}</Suspense>
      </div>
    </>
  );
}
